// extracted by mini-css-extract-plugin
export default {"header":"ModalForm_header__LdnZH","subLabel":"ModalForm_subLabel__H0CNc"};